import { isLocalUrl } from '../utils';

export default function () {
  const widgetName = 'gridGallery';
  const widgetOpts = gridGalleryOpts;
  const $widget = $(`#${widgetName}`);

  const linkedImages = true;

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    textOverImage: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    maxItemsVisible: 12,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
      } else {
        $widget.find('.card-content').remove();
        changeFormatCards(data.items);
        const $cards = $widget.find('.card-widget-item');
        $widget.css('opacity', 1);

        if ($cards.length === 1) {
          $widget.addClass('one-card');
        } else if ($cards.length === 2) {
          $widget.addClass('two-cards');
        } else if ($cards.length === 3) {
          $widget.addClass('three-cards');
        } else if ($cards.length === 4) {
          $widget.addClass('four-cards');
        } else {
          $widget.addClass('more-cards');
        }
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr('href');
      } else {
        const isLocal = isLocalUrl(URL);

        if (!isLocal) {
          $card.attr('target', '_blank');
        } else {
          $card.removeAttr('target');
        }
      }

      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
